<template>
  <v-app id="inspire" @mousemove.native="timeoutLogout">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item link @click="load('dataHome')">
          <v-list-item-action>
            <v-icon v-bind:color="isSelected('dataHome')">mdi-database</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{$t('Menu.Items.dataHome')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="load('networks')">
          <v-list-item-action>
            <v-icon v-bind:color="isSelected('networks')">mdi-lan</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{$t('Menu.Items.networks')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="load('deviceTypes')">
          <v-list-item-action>
            <v-icon v-bind:color="isSelected('deviceTypes')">mdi-folder-network</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{$t('Menu.Items.deviceTypes')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="load('settings')">
          <v-list-item-action>
            <v-icon v-bind:color="isSelected('settings')">settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{$t('Menu.Items.settings')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="admin" link @click="load('admin')">
          <v-list-item-action>
            <v-icon v-bind:color="isSelected('admin')">mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{$t('Menu.Items.admin')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark :extension-height="'0px'">
      <v-spacer></v-spacer>
      <v-toolbar-title>{{$t('Menu.application')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon @click.stop="$emit('logout');">logout</v-icon>
      </v-btn>
      <div slot="extension" style="z-index: -1;">
        
        <br style="z-index: -1;" />
        <v-app-bar-nav-icon  @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <br style="z-index: -1;" />
        <br style="z-index: -1;" />

        <v-card class="mt-3 pr-3" color="white" dense>
          <breadcrumb
            :path="loaded"
            :subpath="subpath"
            :changeLang="changeLangBool"
            @changeloaded="newPath"
          ></breadcrumb>
        </v-card>
      </div>
    </v-app-bar>

    <v-main>
      <br />
      <br />
      <br />
      <networks
        v-if="loadedContent('networks')"
        @subpath="getSubPath"
        :changedPath="changedNetworksPath"
      ></networks>
      <deviceTypes
        v-if="loadedContent('deviceTypes')"
        @subpath="getSubPath"
        :changedPath="changedDeviceTypesPath"
        @clickmarker="clickmarker"
      ></deviceTypes>
      <dataHome
        v-if="loadedContent('dataHome')"
        @subpath="getSubPath"
        :changedPath="changedDataHomePath"
      ></dataHome>
      <settings
        v-if="loadedContent('settings')"
        @subpath="getSubPath"
        @changelang="changeLang"
        :changedPath="changedSettingsPath"
      ></settings>
      <admin
        v-if="loadedContent('admin')"
        @subpath="getSubPath"
        :admin="admin"
        :changedPath="changedAdminPath"
        @clickmarker="clickmarker"
      ></admin>
      <map-comp v-if="loadedContent('map')"></map-comp>
    </v-main>
    <v-footer color="primary" app>
      <span class="white--text">&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import DataHomeComponent from "./DataHome/DataHome";
import SettingsComponent from "./Settings/Settings";
import NetworksComponent from "./Networks/Networks";
import DeviceTypesComponent from "./DeviceTypes/DeviceTypes";
import AdminHomeComponent from "./AdminPanel/AdminHome";
import BreadCrumbComponent from "./Breadcrumb";

import axios from "axios";
import tokenStore from "../store/TokenStore";
import languageStore from "../store/LanguageStore";

export default {
  components: {
    dataHome: DataHomeComponent,
    settings: SettingsComponent,
    breadcrumb: BreadCrumbComponent,
    networks: NetworksComponent,
    deviceTypes: DeviceTypesComponent,
    admin: AdminHomeComponent,
  },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    loaded: null,
    timeOut: null,
    refreshTokenIntervall: null,
    subpath: [""],
    changedSettingsPath: null,
    changedDataHomePath: null,
    changedNetworksPath: null,
    changedDeviceTypesPath: null,
    changedAdminPath: null,
    changeLangBool: false,
    admin: false,
  }),
  methods: {
    loadedContent: function (isLoad) {
     
      return isLoad == this.loaded;
    },
    load: function (toLoad) {
      if(this.$vuetify.breakpoint.name =="sm" || this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "md"){
      this.drawer = !this.drawer;
      }
      if (this.loadedContent(toLoad)) {
        this.newPath(toLoad);
      }
      this.loaded = toLoad;
    },
    newPath: function (value) {
      if (value.lat != null && value.long != null) {
        this.changedDataHomePath = JSON.stringify(value);
      }
      switch (value) {
        case "settings":
          this.changedSettingsPath = value;
          break;
        case "dataHome":
        case "network":
        case "device":
          this.changedDataHomePath = value;
          break;
        case "networks":
        case "netInfo":
          this.changedNetworksPath = value;
          break;
        case "deviceTypes":
        case "devTypeInfo":
        case "manageDataAndAlert":
          this.changedDeviceTypesPath = value;
          break;
        case "admin":
        case "adminNetInfo":
        case "adminDevTypeInfo":
        case "adminDeviceInfo":
        case "adminUserInfo":
        case "adminManageDataAndAlert":
          this.changedAdminPath = value;
          break;
      }
    },
    changeLang: function () {
      this.changeLangBool = true;
      setTimeout(() => {
        this.changeLangBool = false;
      }, 1);
    },
    isSelected: function (isLoad) {
      if (this.loadedContent(isLoad)) return "primary";
    },
    getSubPath: function (value) {
      this.subpath = value;
      this.changedSettingsPath = null;
      this.changedDataHomePath = null;
      this.changedNetworksPath = null;
      this.changedDeviceTypesPath = null;
      this.changedAdminPath = null;
    },
    timeoutLogout: function () {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        clearInterval(this.refreshTokenIntervall);
        this.refreshTokenIntervall = null;
        this.$emit("logout");
      }, process.env.VUE_APP_SESSION_TIMEOUT_SEC * 1000);
    },
    clickmarker: function (value) {
      this.loaded = "dataHome";
      setTimeout(() => {
        this.newPath(value);
      }, 1);
    },
  },
  mounted: function () {
    this.refreshTokenIntervall = setInterval(() => {
      tokenStore.refreshToken();
    }, parseInt(process.env.VUE_APP_TOKEN_SESSION_SEC) * 0.2 * 1000);
    this.loaded = "dataHome";
  },
  beforeMount: function () {
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
        headers: { Authorization: tokenStore.getToken() },
      })
      .then((res) => {
        tokenStore.refreshToken();
        languageStore.setLang(res.data.user.lang);
        this.admin = res.data.user.permissions.admin;
      })
      .catch((err) => {
        console.log(err);
        tokenStore.refreshToken();
      });
  },
};
</script>
